/* ==========================================================================
   App Overrides - Shopify Forms Popup
   --------------------------------------------------------------------------
   Shopify Forms rendert das Popup in einem Shadow DOM (Web Component
   <shopify-forms-embed>, Shadow Root 'open'). Theme-CSS greift dort NICHT.
   Dieses Skript injiziert den CSS-Block aus assets/app-overrides.css in die
   Shadow Root. Der CSS-String unten ist der 1:1-Spiegel der CSS-Datei (ohne
   Kommentare) -> BEIDE Dateien pflegen!

   Lifecycle:
   1. customElements.whenDefined('shopify-forms-embed') -> feuert, sobald das
      Forms-Bundle das Element definiert (egal wie spaet es geladen wird).
   2. Danach kurzes Polling auf host.shadowRoot (Upgrade + erstes Render sind
      asynchron).
   3. Pro Shadow Root ein eigener childList-Observer: rendert die App neu und
      wirft unser <style> raus, wird es sofort wieder eingefuegt.
   4. Document-Observer nur als Fallback (Host wird spaet in den Light DOM
      eingefuegt), rAF-gedrosselt, stoppt bei Erfolg bzw. nach Timeout.
   ========================================================================== */
(function () {
  'use strict';

  var STYLE_ID = 'kb-forms-popup-override';
  var HOST_TAG = 'shopify-forms-embed';
  var HOST_SELECTOR = 'shopify-forms-embed, shopify_forms_embed, [data-shopify-app-name="forms"]';
  var POLL_MS = 250;          // Abstand der shadowRoot-Checks nach whenDefined
  var POLL_MAX = 40;          // 40 x 250ms = 10s
  var HARD_STOP_MS = 120000;  // Sicherheits-Stop des Document-Observers
  var ASYNC_STOP_MS = 30000;  // Stop 30s nach StartAsyncLoading (Forms-Loader aktiv)

  // 1:1-Spiegel von assets/app-overrides.css (ohne Kommentare) - generiert,
  // bei Aenderungen an der CSS-Datei hier nachziehen!
  var CSS = [
    '@media (max-width: 749px) {',
    '  [class*="_formContainer_"] [class*="_gridItemContent_"] {',
    '    padding-top: 8px !important;',
    '    padding-bottom: 4px !important;',
    '  }',
    '  [class*="_formContainer_"] {',
    '    padding-top: 0 !important;',
    '    padding-bottom: 0 !important;',
    '  }',
    '  [class*="_gridItemContent_"] h1,',
    '  [class*="_gridItemContent_"] h2,',
    '  [class*="_gridItemContent_"] h3 {',
    '    white-space: nowrap !important;',
    '    word-break: keep-all !important;',
    '    overflow-wrap: normal !important;',
    '    font-size: clamp(14px, 5vw, 22px) !important;',
    '    margin-top: 0 !important;',
    '    margin-bottom: 2px !important;',
    '  }',
    '  [class*="_gridItemContent_"] p {',
    '    margin-top: 0 !important;',
    '    margin-bottom: 6px !important;',
    '  }',
    '  [class*="_gridItemContent_"] form {',
    '    margin-top: 0 !important;',
    '  }',
    '  [class*="_gridItemContent_"] form > *:first-child,',
    '  [class*="_gridItemContent_"] [class*="_field_"]:first-child,',
    '  [class*="_gridItemContent_"] input[type="text"]:first-of-type,',
    '  [class*="_gridItemContent_"] input[type="email"]:first-of-type {',
    '    margin-top: 0 !important;',
    '  }',
    '  [class*="_overlay_"] {',
    '    align-items: flex-start !important;',
    '  }',
    '  [class*="_overlay_"] [class*="_formContainer_"][class*="_grid_"] {',
    '    max-height: calc(100% - 16px) !important;',
    '    margin: auto 2px !important;',
    '    overflow-y: auto !important;',
    '    -webkit-overflow-scrolling: touch;',
    '    overscroll-behavior: contain;',
    '    grid-template-rows: 240px min-content !important;',
    '  }',
    '  @supports (height: min(1px, 2px)) {',
    '    [data-current-step="form"] [class*="_overlay_"] [class*="_formContainer_"][class*="_grid_"] {',
    '      height: min(calc(100% - 16px), 565px) !important;',
    '      grid-template-rows: minmax(0, 1fr) min-content !important;',
    '    }',
    '  }',
    '  @supports (height: 1svh) {',
    '    [class*="_overlay_"] [class*="_formContainer_"][class*="_grid_"] {',
    '      max-height: calc(100svh - 16px) !important;',
    '    }',
    '    [data-current-step="form"] [class*="_overlay_"] [class*="_formContainer_"][class*="_grid_"] {',
    '      height: min(calc(100svh - 16px), 565px) !important;',
    '    }',
    '  }',
    '  [class*="_formContainer_"][class*="_grid_"] [class*="_imageLoaded_"] {',
    '    height: 100% !important;',
    '    min-height: 0 !important;',
    '    overflow: hidden !important;',
    '    background-position: center 25% !important;',
    '  }',
    '  [class*="_formContainer_"][class*="_grid_"] [class*="_formContainerCloseButtonPosition_"] {',
    '    position: sticky !important;',
    '    grid-row: 1 / -1 !important;',
    '    grid-column: 1 !important;',
    '    align-self: start !important;',
    '    justify-self: end !important;',
    '    top: 14px !important;',
    '    right: auto !important;',
    '    margin-right: 14px !important;',
    '    height: 0 !important;',
    '    overflow: visible !important;',
    '    line-height: 0 !important;',
    '    z-index: 5 !important;',
    '  }',
    '  [class*="_gridItemContent_"] input[type="text"],',
    '  [class*="_gridItemContent_"] input[type="email"],',
    '  [class*="_gridItemContent_"] input[type="tel"],',
    '  [class*="_gridItemContent_"] input[type="number"],',
    '  [class*="_gridItemContent_"] select,',
    '  [class*="_gridItemContent_"] textarea {',
    '    font-size: 16px !important;',
    '  }',
    '}',
    '[class*="_teaserContainer_"] [class*="_formCloseButton_"] {',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  box-sizing: border-box !important;',
    '  width: 44px !important;',
    '  height: 44px !important;',
    '  margin: -12px -12px -12px -4px !important;',
    '  border-radius: 10px !important;',
    '}',
    '[class*="_teaserContainer_"] [class*="_formCloseButton_"] > svg {',
    '  width: 14px !important;',
    '  height: 14px !important;',
    '}',
    '[class*="_teaserContainer_"] [class*="_formCloseButton_"]:hover {',
    '  background-color: rgba(0, 0, 0, 0.06) !important;',
    '}',
    '@media (max-width: 749px) and (max-height: 600px) {',
    '  [class*="_gridItemContent_"] [class*="_formHeader_"] {',
    '    margin-top: 0 !important;',
    '    margin-bottom: 12px !important;',
    '  }',
    '  [class*="_gridItemContent_"] [class*="_formDisclaimer_"] {',
    '    margin-top: 6px !important;',
    '  }',
    '}'
  ].join('\n');

  var done = false;
  var docObserver = null;
  var stopTimer = null;

  // Style in Root (ShadowRoot | document.head) einfuegen; true = vorhanden/eingefuegt.
  // querySelector statt getElementById: <head> hat kein getElementById.
  function injectInto(root) {
    if (!root || typeof root.querySelector !== 'function') return false;
    if (root.querySelector('#' + STYLE_ID)) return true;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
    return true;
  }

  // Shadow Root dauerhaft beobachten: rendert die App neu (innerHTML-Reset),
  // fliegt unser <style> raus -> sofort wieder rein. Nur childList = praktisch kostenlos.
  function watchRoot(root) {
    if (root.__kbWatched) return;
    root.__kbWatched = true;
    new MutationObserver(function () { injectInto(root); })
      .observe(root, { childList: true });
  }

  function stopDocObserver() {
    if (docObserver) { docObserver.disconnect(); docObserver = null; }
    if (stopTimer) { clearTimeout(stopTimer); stopTimer = null; }
  }

  // true, sobald mindestens eine Shadow Root (oder der Head) versorgt ist
  function patch() {
    var ok = false;
    var hosts = document.querySelectorAll(HOST_SELECTOR);
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) {
        injectInto(hosts[i].shadowRoot);
        watchRoot(hosts[i].shadowRoot);
        ok = true;
      }
    }
    // Falls die App kein Shadow DOM nutzt: <head> reicht (Theme-CSS greift dann eh)
    if (!ok && document.querySelector('[class*="_formContainer_"]')) {
      ok = injectInto(document.head);
    }
    if (ok && !done) { done = true; stopDocObserver(); }
    return ok;
  }

  // Nach customElements.define() kann die Shadow Root noch fehlen
  // (Upgrade + erstes Render sind async) -> kurz pollen.
  function pollForShadow(remaining) {
    if (patch() || remaining <= 0) return;
    setTimeout(function () { pollForShadow(remaining - 1); }, POLL_MS);
  }

  function armStop(ms) {
    if (stopTimer) clearTimeout(stopTimer);
    stopTimer = setTimeout(stopDocObserver, ms);
  }

  function start() {
    // Primaerer Trigger: Forms-Bundle definiert das Custom Element (egal wie spaet)
    if (window.customElements && typeof customElements.whenDefined === 'function') {
      try {
        customElements.whenDefined(HOST_TAG)
          .then(function () { pollForShadow(POLL_MAX); })
          .catch(function () { /* ungueltiger Name o.ae. -> Fallback bleibt aktiv */ });
      } catch (e) {}
    }

    if (patch()) return;

    // Fallback: Host wird spaet in den Light DOM eingefuegt (z.B. Section Rendering).
    // rAF-gedrosselt, damit Slider/Cart-Drawer nicht pro Mutation querySelectorAll ausloesen.
    var scheduled = false;
    docObserver = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || setTimeout)(function () {
        scheduled = false;
        patch();
      });
    });
    docObserver.observe(document.documentElement, { childList: true, subtree: true });

    // Sicherheits-Stop: 120s hart, bzw. 30s nachdem der Forms-Loader tatsaechlich
    // gestartet wurde (StartAsyncLoading = Scroll/Touch/Maus oder 5s-Timeout).
    armStop(HARD_STOP_MS);
    document.addEventListener('StartAsyncLoading', function () {
      if (!done) armStop(ASYNC_STOP_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
